import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import '../FishFinderBuilder.css';
import '../foundation.css';
import TopNavBar from './TopNavBar';
import Footer from './Footer';

const SharedLayout = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const isComparisonPage =
    location.pathname === '/compare' ||
    location.pathname.startsWith('/comparisons');
  const isEarlyAccessPage = location.pathname === '/early-access';
  const isSeasonalLaunchPage = location.pathname.startsWith('/ice-fishing/');
  const isGearPage = location.pathname === '/price-comparison' || location.pathname === '/ice-fishing' || location.pathname.startsWith('/gear/') || location.pathname.startsWith('/simple-products/') || location.pathname === '/ice-fishing/new-gear-2026-27';

  useEffect(() => {
    if (!location.hash && (isGearPage || isSeasonalLaunchPage || location.pathname.startsWith('/simple-products/'))) {
      window.scrollTo(0, 0);
    }
  }, [location.pathname, location.hash, isGearPage, isSeasonalLaunchPage]);

  return (
    <div
      className={`shared-layout${isHomePage ? ' home-page' : ''}${
        isComparisonPage ? ' comparison-page' : ''
      }${isEarlyAccessPage ? ' early-access-page' : ''}${
        isSeasonalLaunchPage ? ' seasonal-launch-page' : ''
      }${isGearPage ? ' gear-page' : ''
      }`}
    >
      <TopNavBar />
      <main className="shared-main">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default SharedLayout;
